import { createFileRoute } from '@tanstack/react-router';

import { PersonPageView } from '@/features/services/person-page';
import { bootSession } from '@/lib/auth/session';

/** Public: a person's page (shareable; signing in adds the actions). */
export const Route = createFileRoute('/p/$slug')({
  beforeLoad: async () => {
    // Best effort: a signed-in person gets the actions, everyone else the page.
    await bootSession().catch(() => undefined);
  },
  component: PersonRoute,
});

function PersonRoute() {
  const { slug } = Route.useParams();
  return <PersonPageView slug={slug} />;
}
